import { makeQuery } from '../types';
import { UserInfoForAdminDto } from '@core/models';

type Input = { email: string };
type Output = { getUserInfo: UserInfoForAdminDto };

export const getUserInfo = makeQuery<Output, Input>(`
query GetUserInfo($email: String!) {
  ayn {
    getUserInfo(email: $email) {
      email
      name
      surname
      userSubscriptionId
      subscriptionPackageName
      country
      owner {
        email
        name
        surname
        country
      }
      subusers {
        email
        name
        surname
        country
      }
    }
  }
}

`);
